import { render, staticRenderFns } from "./Form3ProcessHeader.vue?vue&type=template&id=12af8299&scoped=true"
import script from "./Form3ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form3ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form3ProcessHeader.vue?vue&type=style&index=0&id=12af8299&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af8299",
  null
  
)

export default component.exports